<template>
  <div>

    <approval-remarks :row-data="actionData" :steps="actionData.steps" :legal-step="3" />

    <div v-if="legalApproved">
      <section v-if="isTowerCo()">

        <el-form label-position="top" :inline="true">

          <el-form-item label="Approval">
            <el-select v-model="step.approvedStatus"
            @change="approval()"
            placeholder="Select"
            :disabled="disabled">
            <el-option label="Pending" value="Pending" />
            <el-option label="Rejected" value="Rejected" />
            <el-option label="Conditional" value="Conditional" />
            <el-option label="Approved" value="Approved" />
          </el-select>
        </el-form-item>

        <el-form-item label="Date" v-if="!isPending">
          <el-date-picker v-model="step.approved_at"
          :format="dateFormat"
          :disabled="disabled" />
        </el-form-item>

        <el-form-item label="Approval Remarks" v-if="!isPending">
          <div class="html-remarks">
            <html-input v-if="(isApprover() && canAccess('project'))"
            v-model="step.remarks"  :disabled="disabled" />
          </div>
        </el-form-item>

        <el-form-item v-if="!disabled && !isPending" style="padding-top: 3em;">
          <el-button :type="approvalButton" icon="fa fa-check" @click="sendApproval()"
          :disabled="(disabled || !step.approvedStatus || step.approvedStatus === 'Pending')">
          Send {{step.approvedStatus}} e-Mail
        </el-button>
      </el-form-item>

      <el-row>
        <el-form :inline="true">
          <el-form-item label="Deposit Returned">
            <el-switch active-text="Yes" inactive-text="No" v-model="step5.depositReturned"  :disabled="disabled" />
          </el-form-item>

          <el-form-item label="Amount" v-if="step5.depositReturned">
            <el-input type="number" v-model="step5.amount"
            :disabled="disabled || !step5.depositReturned">
            <template slot="prepend">{{currencyLabel}}</template>
          </el-input>
        </el-form-item>
      </el-form>
      </el-row>

      <el-form-item v-if="step5.deposit > 0" label="Deposit Returned">
        <strong v-text="this.formatMoney(step5.deposit, 0)"></strong>
      </el-form-item>

      <div v-if="!(step5.approved && (step.approvedStatus === 'Approved' || step.approvedStatus === 'Pending'))">
        <el-form-item label="Re-submission Remarks">
          <div class="html-remarks">
            <p v-if="step5.resubmitRemarks" v-safe-html="step5.resubmitRemarks"></p>
            <p v-else class="text-muted">No remarks</p>
          </div>
        </el-form-item>
      </div>

    </el-form>

  </section>

  <!-- Client view from here on down -->
  <section v-else>

    <el-form label-position="left" label-width="132px">

          <el-form-item label="Approval Status" v-if="step5p1">
            <h2>{{step5p1.approvedStatus ? step5p1.approvedStatus : 'Pending' }}
            &nbsp;
            <span v-if="!step5p1.approved">Approval</span>
            &nbsp;
            <i v-if="step5p1.approved" class="fa fa-check-circle text-success"></i>
            <i v-if="step5p1.approvedStatus === 'Conditional'" class="fa fa-question-circle text-warning"></i>
            <i v-if="step5p1.approvedStatus === 'Rejected'" class="fa fa-exclamation-circle text-danger"></i>
            <i v-if="!step5p1.approved && (step5p1.approvedStatus !== 'Rejected' && step5p1.approvedStatus !== 'Conditional')" class="fa fa-info-circle text-muted"></i>
            &nbsp;</h2>
            <i v-if="step5p1.approved && step5p1.approvedStatus === 'Approved'">{{formatFriendlyDate(step5p1.approved_at)}}</i>
          </el-form-item>

          <el-form-item v-if="step5p1 && step5p1.remarks" label="Approval Remarks">
            <div style="width: 41.7vw; overflow: auto;">
              <p v-safe-html="step5p1.remarks"></p>
            </div>
          </el-form-item>
        </el-form-item>


    <div v-if="!(step5p1 && step5p1.approved && (step5p1.approvedStatus === 'Pending' || step5p1.approvedStatus === 'Approved'))">

      <el-form-item label="Re-submission Remarks">
        <div v-if="isTelco()">
            <html-input v-model="step5.resubmitRemarks" :disabled="disabled" />
        </div>
        <div v-else style="width: 41.7vw; overflow: auto; text-align: left;">
            <p v-if="step5.resubmitRemarks" v-safe-html="step5.resubmitRemarks"></p>
            <p v-else class="text-muted">No remarks</p>
        </div>
      </el-form-item>

      </div>
    </el-form>
  </section>

  </div>

</div>

</template>



<script>

import {settings} from '@/components/Data'

import RequestMixins from '@/mixins/RequestMixins'

import FileDownload from '@/components/atoms/files/FileDownload'
import FileUpload from '@/components/atoms/files/FileUpload'

import ApprovalRemarks from '@/components/requests/workflow/ApprovalRemarks'

export default {

  mixins: [RequestMixins],

  components: {
    ApprovalRemarks,
    FileDownload,
    FileUpload
  },


  props: {

    rowData: {
      type: Object,
      required: true
    },

    rowIndex: {
      type: Number,
      required: true
    },

    stepData: {
      type: Object,
      default: null
    },

    readOnly: {
      type: Boolean,
      default: true
    }

  },



  methods: {

    setStep (data) {
      if (data) {
        this.step = data
      }
    },

    approval () {

      if (this.step && (this.step.approvedStatus === 'Approved' || this.step.approvedStatus === 'Rejected')) {
        this.step.approved = true
        this.step.approved_by = this.userName()
        this.step.approved_at = this.formatDateSql(new Date())

        this.actionData.approved_by = this.step.approved_by
        this.actionData.approved_at = this.step.approved_at
        this.actionData.approvalType = 'Final ' + this.step5.approvedStatus

      } else {

        this.step.approved = false
        this.step.approved_by = null
        this.step.approved_at = null

        this.actionData.approvalType = this.step5.approvedStatus
        this.actionData.approved_by = null
        this.actionData.approved_at = null
      }

      this.saveStep(this.step)
    },


    sendApproval () {
      this.approvalAlert(this.rtxInfo,
        this.step.approvedStatus,
        this.formatDate(this.step.approved_at),
        this.step.remarks, this.step2.siteId)
    }

  },



  data () {

    return {
      currencyLabel: settings.currency,
      dateFormat: settings.selectDateFormat,
      actionData: this.rowData,
      step: this.stepData,
      step2: this.rowData.state.step2,
      step3: this.rowData.state.step3,
      step5: this.rowData.state.step5,
      legalApproved: (this.rowData.status === 'Closed') ? true : this.rowData.state.step3.legalApproved,
      step5p1: null,
      rtxInfo: this.info(this.rowData, this.stepData, 5),
      disabled: this.isViewOnly() || this.readOnly
    }

  }, // data



  created () {
    if (this.step) {
      // To handle existing RTx without this flag.
      this.step.legalApproved = (this.actionData.status !== 'Closed' ? this.step.legalApproved : true)

      if (!this.readOnly || !this.isViewOnly()) {
        this.findStep(this.stepData.id, this.setStep)
      }

    }

  },


  mounted () {

    if (this.step && !this.isViewOnly()) {

      if (this.step.stepNo === 5 && this.step.partyNo === 1) {
        this.step5p1 = this.step
      } else {
        this.step5p1 = this.findWorkflowStep(5, 1, this.rowData.steps)
      }

    }

  },


  beforeDestroy () {
    if (!this.readOnly || !this.isViewOnly()) {

      if (!this.readOnly && this.step) {

        this.$emit('updated', this.step)

        if (this.step.stepNo === 5 && this.step.partyNo === 1) {
          this.step5p1 = this.step
        }

        this.saveStep(this.step, null, this.actionData, true)
      }
    }

  }

}
</script>
